import React, { useState } from 'react';
import { Bell, ShoppingCart, Search, Menu, User, LogOut, Settings, ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { logout } from '@/features/auth/authSlice';

interface TopbarProps {
  onToggleSidebar?: () => void;
}

const Topbar: React.FC<TopbarProps> = ({ onToggleSidebar }) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(state => state.auth);
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-gray-200 bg-white" style={{

      zIndex: "99999",
      height: "75px"
    }}>
      <div className="px-4 lg:px-6 h-16 flex items-center justify-around" style={{
        paddingTop: "13px"
      }}>
        {/* Left: Brand + Burger */}
        <div className="flex items-center gap-3">
          <button
            aria-label="Toggle sidebar"
            className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-md border border-gray-200 hover:bg-gray-50"
            onClick={onToggleSidebar}
          >
            <Menu className="h-5 w-5 text-gray-700" />
          </button>
          <div className='side-header' style={{
            width:"288px"
          }}>
            <Link to="/dashboard" className="header-brand1">
              {/* <span className="inline-block h-8 w-8 rounded-lg bg-blue-600" /> */}
              <img src={'https://nocache-appxdb-v2.classx.co.in/subject/2024-12-24-0.7611780787393996.jpg'} alt="Admin" className="header-brand-img light-logo1" style={{ width: '65px' }} />
              {/* <span className="font-semibold text-gray-900">Vedemy Admin</span> */}
            </Link>
          </div>

        </div>

        {/* Middle: Search */}
        <div className="hidden md:flex flex-1 max-w-xl mx-4">
          <div className="relative w-full" style={{
            marginLeft:"10px"
          }}>
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="text"
              placeholder="Search..."
              className="w-full pl-10 pr-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
              style={{
                paddingLeft:"35px"
              }}
            />
          </div>
        </div>

        {/* Right: Icons + Profile */}
        <div className="flex items-center gap-2 md:gap-3">
          <button className="relative inline-flex h-10 w-15 items-center justify-center rounded-md border border-gray-200 hover:bg-gray-50">
            <ShoppingCart className="h-5 w-5 text-gray-700" />
            <span className="absolute -top-1 -right-1 inline-flex items-center justify-center rounded-full bg-red-600 text-white text-[10px] h-5 w-5">4</span>
          </button>
          <button className="relative inline-flex h-10 w-15 items-center justify-center rounded-md border border-gray-200 hover:bg-gray-50">
            <Bell className="h-5 w-5 text-gray-700" />
            <span className="absolute -top-1 -right-1 inline-flex items-center justify-center rounded-full bg-blue-600 text-white text-[10px] h-5 w-5">9</span>
          </button>

          {/* Profile dropdown */}
          <div className="relative group">
            <button className="h-10 px-3 inline-flex items-center gap-2 rounded-md border border-gray-200 hover:bg-gray-50"
              onClick={() => setOpen(!open)}
            >
              <div className="h-7 w-7 rounded-full bg-blue-100 flex items-center justify-center">
                <User className="h-4 w-4 text-blue-600" />
              </div>
              <span className="hidden sm:inline text-sm text-gray-800 font-medium">
                {user?.firstName || 'Super'} {user?.lastName || 'Admin'}
              </span>
              <ChevronDown
                className={`h-4 w-4 text-gray-500 transition-transform duration-200 ${open ? "rotate-180" : ""
                  }`}
              />
            </button>
            {open && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                <Link
                  to="/profile"
                  className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  onClick={() => setOpen(false)}
                >
                  <User className="h-4 w-4 mr-2" /> Profile
                </Link>
                <Link
                  to="/settings"
                  className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  onClick={() => setOpen(false)}
                >
                  <Settings className="h-4 w-4 mr-2" /> Settings
                </Link>
                <button
                  onClick={() => {
                    setOpen(false);
                    handleLogout();
                  }}
                  className="w-full text-left flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                >
                  <LogOut className="h-4 w-4 mr-2" /> Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Topbar;
